import { mockProvider } from "./providers/mock";
import { geminiProvider } from "./providers/gemini";
import type {
  OrchestratorResult,
  ProviderName,
  VisionInput,
  VisionOptions,
  VisionProvider
} from "./types";

// Simplified to single-provider (Gemini via Pages Function) with mock fallback.
// The previous multi-provider reconciliation layer was kept dormant.
const ALL: Record<Exclude<ProviderName, "claude" | "openai">, VisionProvider> = {
  mock: mockProvider,
  gemini: geminiProvider
};

function selectProvider(): VisionProvider {
  const env = (import.meta.env.VITE_VISION_PROVIDERS as string | undefined) ?? "gemini";
  const first = env.split(",")[0]?.trim().toLowerCase();
  if (first === "mock") return ALL.mock;
  return ALL.gemini.enabled ? ALL.gemini : ALL.mock;
}

export async function estimateMeal(
  input: VisionInput,
  options?: VisionOptions
): Promise<OrchestratorResult> {
  const provider = selectProvider();
  try {
    const reconciled = await provider.estimate(input, options);
    return {
      reconciled,
      perProvider: [{ name: provider.name, result: reconciled }],
      disagreement_pct: 0
    };
  } catch (err) {
    // Preserve cancellation upstream — don't wrap as a generic failure.
    if ((err as Error)?.name === "AbortError") throw err;
    const message = (err as Error)?.message ?? String(err);
    throw new Error(`Vision (${provider.name}) failed: ${message}`);
  }
}
